import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, PRODUCTS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const ProductList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.string, show: false, width: 80 },
			{
				Header: 'productName',
				accessor: 'name',
				filterType: FilterType.string,
				renderCell: ListComponents.PRODUCT_IMAGE,
				width: 120,
				showOnMobile: true
			},
			{ Header: 'sku', accessor: 'sku', filterType: FilterType.string, width: 100 },
			{ Header: 'hsCode', accessor: 'hsCode', filterType: FilterType.string, width: 100 },
			{ Header: 'barcode', accessor: 'barcode', filterType: FilterType.string, width: 100 },
			{
				Header: 'secondBarcode',
				accessor: 'secondBarcode',
				filterType: FilterType.string,
				width: 100,
				show: false
			},
			{
				Header: 'price',
				accessor: 'price',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY,
				width: 120
			},
			{ Header: 'tax', accessor: 'taxAmount', filterType: FilterType.string, show: false, width: 100 },
			{ Header: 'category', accessor: 'category', filterType: FilterType.string, show: false },
			{
				Header: 'preorderOnly',
				accessor: 'preorder',
				filterType: FilterType.enum,
				enumName: ENUMS.YES_NO,
				renderCell: ListComponents.STATUS,
				roleName: 'OMSModule'
			},
			{
				Header: 'storeName',
				accessor: 'brandName',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.BRAND_NAME,
				show: false,
				renderCell: ListComponents.BRAND_LOGO,
				roleName: 'BrandingModule'
			},
			{
				Header: 'bundleProduct',
				accessor: 'bundleProduct',
				filterType: FilterType.enum,
				enumName: ENUMS.YES_NO,
				show: false,
				renderCell: ListComponents.STATUS,
				roleName: ['WMSAdvanceModule', 'IMSModule']
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.PRODUCTS}
				columns={columns}
				fetchUrl={PRODUCTS.GET_PRODUCT_LIST}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.PRODUCT}
				exportName="products"
			/>
		</TabTableContainer>
	);
};

export default ProductList;
